import { render, staticRenderFns } from "./sc-category.vue?vue&type=template&id=6c969a96&scoped=true&"
import script from "./sc-category.vue?vue&type=script&lang=js&"
export * from "./sc-category.vue?vue&type=script&lang=js&"
import style0 from "./sc-category.vue?vue&type=style&index=0&id=6c969a96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c969a96",
  null
  
)

export default component.exports